// popup alternative
class CustomPopup extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("[data-popup-close]").forEach((closeTrigger) => {
      closeTrigger.addEventListener("click", this.hide.bind(this, false));
    });
    this.addEventListener("keyup", (event) => {
      if (event.code?.toUpperCase() === "ESCAPE") this.hide();
    });

    // this.addEventListener('click', (event) => {
    //     if (event.target === this) this.hide();
    // });
  }

  show() {
    document.body.classList.add("overflow-hidden");
    this.classList.add("visible");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("visible");
  }
}
customElements.define("custom-popup", CustomPopup);

class CustomPopupOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", () => {
      const popup = document.querySelector(this.getAttribute("data-popup"));
      if (popup) popup.show();
    });
  }
}
customElements.define("custom-popup-opener", CustomPopupOpener);

class ToolTip extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.inner = this.querySelector("[data-tool-tip-inner]");
    this.closeButton = this.querySelector("[data-tool-tip-close]");
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");
    this.toolTipTitle = this.querySelector("[data-tool-tip-title]");

    this.triggers = document.querySelectorAll("[data-tool-tip-trigger]");

    document.addEventListener("tooltip:open", (e) => {
      this._open(e.detail.context, e.detail.content);
    });
  }

  _open(context, insertedHtml) {
    this.toolTipContent.innerHTML = insertedHtml;

    // Ensure we set a title for product availability
    if (context != "store-availability") {
      this.toolTipTitle.remove();
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this._close();
      });
    }

    document.documentElement.addEventListener("click", () => {
      this._close();
    });

    document.documentElement.addEventListener("keydown", (event) => {
      if (event.code === "Escape") this._close();
    });

    this.el.dataset.toolTipOpen = true;
    this.el.dataset.toolTip = context;
  }

  _close() {
    this.toolTipContent.innerHTML = "";
    this.el.dataset.toolTipOpen = "false";
    this.el.dataset.toolTip = "";

    this.closeButton.removeEventListener("click");
    document.documentElement.removeEventListener("click");
    document.documentElement.removeEventListener("keydown");
  }
}

customElements.define("tool-tip", ToolTip);

class ToolTipTrigger extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");
    this.init();
  }

  init() {
    const toolTipOpen = new CustomEvent("tooltip:open", {
      detail: {
        context: this.dataset.toolTip,
        content: this.toolTipContent.innerHTML,
      },
      bubbles: true,
    });

    this.el.addEventListener("click", (e) => {
      e.stopPropagation();
      this.dispatchEvent(toolTipOpen);
    });
  }
}
customElements.define("tool-tip-trigger", ToolTipTrigger);
(function() {
  function isPreorderActive() {
    return !!document.querySelector(
      '.restock-rocket-preorder-description, .restock-rocket-form-input, .restock-rocket-preorder, .stoq-preorder'
    );
  }

  function enablePreorderButton() {
    if (!isPreorderActive()) return;
    var btns = document.querySelectorAll(
      'button.restock-rocket-preorder-button, button.add-to-cart, form[action*="/cart/add"] [type="submit"][name="add"]'
    );
    btns.forEach(function(btn) {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.classList.remove('opacity-50','cursor-not-allowed','disabled');
      btn.style.pointerEvents = 'auto';
    });
  }

  // Corre cada 100ms siempre que la PDP esté abierta
  setInterval(enablePreorderButton, 100);
})();


/******** Test ATC button change ***9*********/
if(document.querySelector('.test-1-variant-1') && window.location.pathname.includes('/products/')){
  const handleATCSticky = (e)=>{
    const atcButton = document.querySelector('.test-1-variant-1 form[id^=product-form-] .add-to-cart-container button[type=submit]');
        const atcButtonContainer = document.querySelector('.test-1-variant-1 form[id^=product-form-] .add-to-cart-container');
    if(atcButtonContainer.getBoundingClientRect().bottom< 0){
        // Add sticky class:
          atcButtonContainer.classList.add('sticky');
    }else{
        atcButtonContainer.classList.remove('sticky');
    }
  }

  document.addEventListener('scroll', handleATCSticky)
}

/******** Test ATC button change End *********/

/******** Test Cart Checkout Btn changes ********/
(function() {
  const isVariant3 = !!document.querySelector('.test-3-variant-1, .test-3-variant-2');
  const isVariant4 = !!document.querySelector('.test-4-variant-1');

  const cart = document.querySelector('#unicorn-cart-block');
  const config = {attributes: true, childList: true,subtree:true }

  if (!isVariant3 && !isVariant4) return;

  const updateCheckoutButton = (observer) => {
    if(observer) observer.disconnect();
    const btn = document.querySelector('#unicorn_checkout_submit');
    const appliedClass = 'test-4-variant-1-checkout-btn';

    if (btn && !btn.classList.contains(appliedClass)) {
      btn.innerText = `Secure ${btn.innerText}`;
      btn.classList.add(appliedClass);
    }

    observer.observe(cart, config);
  }

const renderFreeShipping = (observer) => {
  if (observer) observer.disconnect();

  const threshold = 100;
  const cartPrice = (window.unicornCartData?.totalPrice?.value || 0) / 100;
  const currencySymbol = window.unicornGlobal?.settings?.money?.[0] || '$';

  const unicornBlocks = document.querySelector('#unicorn_cart_main_blocks');
  const existingSection = document.querySelector('.test--free-shipping-section');

  if (cartPrice <= 0) {
    if (existingSection) existingSection.remove();
    if (observer && typeof cart !== 'undefined') observer.observe(cart, config);
    return;
  }

  if (!unicornBlocks) {
    if (observer && typeof cart !== 'undefined') observer.observe(cart, config);
    return;
  }

  if (!existingSection) {
    const shippingHtml = `
      <div class='test--free-shipping-section'>
          <p class='test--free-shipping-text'></p>
          <div class='test--free-shipping-progress-bar-container'>
            <div class='test--free-shipping-progress-bar'></div>
          </div>
      </div>
    `;
    unicornBlocks.insertAdjacentHTML('afterbegin', shippingHtml);
  }

  const section = unicornBlocks.querySelector('.test--free-shipping-section');
  const textEl = section.querySelector('.test--free-shipping-text');
  const barEl = section.querySelector('.test--free-shipping-progress-bar');

  const remaining = Math.max(0, threshold - cartPrice);
  const progressPercent = Math.min(100, (cartPrice / threshold) * 100);
  const isQualified = cartPrice >= threshold;

  if (document.querySelector('.test-3-variant-1')) {
    section.style.display = 'flex';
    barEl.style.width = `${progressPercent}%`;
    
    const statusText = isQualified 
      ? "You’ve got free shipping." 
      : `You're only ${currencySymbol}${remaining.toFixed(2)} away from free shipping.`;
    
    if (textEl.innerText !== statusText) textEl.innerText = statusText;

  } else if (document.querySelector('.test-3-variant-2')) {
    if (isQualified) {
      section.style.display = 'flex';
      textEl.innerText = "You’ve got free shipping.";
      barEl.style.display = 'none';
    } else {
      section.style.display = 'none';
    }
  }

  if (observer && typeof cart !== 'undefined') {
    observer.observe(cart, config);
  }
};

  const cartChangeHandler = (mutationList, observer) => {
    if (isVariant4) {
      setTimeout(() => {
        updateCheckoutButton(observer);
      }, 1);
    }
    if (isVariant3) {
      // The client is only offering free shipping in US and AU
      if(Shopify.currency.active == "USD" || Shopify.currency.active == "AUD"){
        let unicornCartSection = document.querySelector('#unicorn_cart_main_blocks')
        // Check if window.unicornCartData is available before calling the function, otherwise check until it is
        if(window.unicornCartData && unicornCartSection)
          renderFreeShipping(observer);
        else{
          const isUnicornReady = setInterval(()=>{
            unicornCartSection = document.querySelector('#unicorn_cart_main_blocks')
            if(window.unicornCartData && unicornCartSection){
              clearInterval(isUnicornReady)
              renderFreeShipping(observer);
            }
          }, 500)
        }
      }
    }
  };

  
  if (cart) {
    const observer = new MutationObserver(cartChangeHandler);
    observer.observe(cart, config);
    
    cartChangeHandler([],observer);
  } else {
    console.warn('Unicorn cart block not found');
  }
})();
/******** Test Cart Checkout Btn changes End*****/


/*** Test Homepage Collection ***********/
function initHorizontalScrollCheck() {
  if (!document.querySelector('.test-5-variant-1')) return;

  const container = document.querySelector('.homepage-visual-category');
  const grid = container?.querySelector('.grid');

  if (!container || !grid) return;

  grid.addEventListener('scroll', () => {
    const isAtEnd = Math.ceil(grid.scrollLeft) + grid.clientWidth >= grid.scrollWidth - 50;

    if (isAtEnd) {
      container.classList.add('reachedEnd');
    } else {
      container.classList.remove('reachedEnd');
    }
  });
}
initHorizontalScrollCheck();
/*** Test Homepage Collection End *******/


/*** Test PDP Changes *******/
class PDPTestVariant {
    constructor() {
        this.isVariant = document.querySelector('.test-2-variant');
        if (!this.isVariant) return;

        this.init();
    }

    init() {
        this.mergePriceAndReviews();
        this.injectSentimentText();
        this.moveSizeGuideLink();
        this.moveVendorText();
        this.moveBenefits();
        this.hideEmptyAppDivs();
        this.moveHeroVideo();
        this.injectVerticalThumbnails();
    }

    mergePriceAndReviews() {
        const priceBlock = document.querySelector('.product-price-block');
        const ratingsWidget = document.querySelector('.klaviyo-star-rating-widget')?.closest('.mt-8');

        if (priceBlock && ratingsWidget) {
            const combinedContainer = document.createElement('div');
            combinedContainer.classList.add('combined-price-rating-container');

            priceBlock.parentNode.insertBefore(combinedContainer, priceBlock);
            combinedContainer.appendChild(ratingsWidget);
            combinedContainer.appendChild(priceBlock);
        }
    }

    injectSentimentText() {
        const titleBlock = document.querySelector('.product-title-block');
        // Need to check if there's a sentiment text to begin with
        const originalSentimentText = document.querySelector('.pdp-hero-video');
        
        if (titleBlock && originalSentimentText && originalSentimentText.innerText != '') {
            const sentimentText = document.createElement('div');
            sentimentText.classList.add('product-sentiment-message');
            sentimentText.innerText = originalSentimentText.innerText.replace(/\s+/g, ' ').trim();
            titleBlock.after(sentimentText);
        }
    }

    moveSizeGuideLink() {
        const sizeGuide = document.querySelector('.size-guide');
        const variantPicker = document.querySelector('.product-variant-picker-block');

        if (sizeGuide && variantPicker) {
            variantPicker.appendChild(sizeGuide);
        }
    }

    moveVendorText() {
        const vendorBlock = document.querySelector('.vendorText');
        const combinedPrice = document.querySelector('.combined-price-rating-container');

        if (vendorBlock && combinedPrice) {
            combinedPrice.after(vendorBlock);
        }
    }

    moveBenefits() {
        const benefits = document.querySelector('.benefits');
        const atcSection = document.querySelector('[x-data="ProductForm"]');

        if (benefits && atcSection) {
            atcSection.after(benefits);
        }
    }

    hideEmptyAppDivs() {
        const appDivsToCheck = document.querySelectorAll('#simple-bundles-io-options, .globo-product-groups-detail');
        appDivsToCheck.forEach((div) => {
            if (div.children.length === 0) {
                div.closest('.mt-8').style.display = 'none';
            }
        });
    }

    moveHeroVideo() {
      const videosAndTemplateMap = {
        "douspartgold": "https://cdn.shopify.com/videos/c/o/v/ed1059af3a584f1db6b5615f2f03eabd.mp4",
        "douspartsilver": "https://cdn.shopify.com/videos/c/o/v/5fee6f92ae3b4652acae2433401d2593.mp4",
        "mementogold": "https://cdn.shopify.com/videos/c/o/v/8611bacdc66147d0b41085b3fde81860.mp4",
        "memento": "https://cdn.shopify.com/videos/c/o/v/371b55a5bb804a1e8f489cfc838f6fa9.mp4",
        "sacredheartgold": "https://cdn.shopify.com/videos/c/o/v/d9ea3469c4fe4d0abcedfcf146790320.mp4",
        "sacredheart": "https://cdn.shopify.com/videos/c/o/v/6ba78aa5550044beb2fe10192abfb8b7.mp4",
        "tilldeathdiamond": "https://cdn.shopify.com/videos/c/o/v/230fa706f02a4bd8a401f1ff3552c21a.mp4",
        "tilldeathsolidgold": "https://cdn.shopify.com/videos/c/o/v/8a5b7c2310d7402f99c0da7c4a8ec0ec.mp4",
        "tilldeathgold": "https://cdn.shopify.com/videos/c/o/v/5e9b9f1c7a714b1bb9d1e13a0fef7a55.mp4",
        "breakable-goldsilver": "https://cdn.shopify.com/videos/c/o/v/62ea000ac8d043da8c6f54c6aea7b130.mp4",
        "breakable-heart": "https://cdn.shopify.com/videos/c/o/v/d71832b546d94fb8bbf36a4d059d2e4a.mp4",
        "tilldeath": "https://cdn.shopify.com/videos/c/o/v/5e9b9f1c7a714b1bb9d1e13a0fef7a55.mp4"
      }

      const template = document.querySelector('body').getAttribute('data-template');
      const newVideoURL = videosAndTemplateMap[template];

        const heroVideo = document.querySelector('.pdp-hero-video');
        const newHeroLocation = document.querySelector('.pdp-hero-new-place');
        if (heroVideo && newHeroLocation) {
          if(newVideoURL) heroVideo.querySelector('video source').src = newVideoURL
            newHeroLocation.after(heroVideo);
        }
    }

    injectVerticalThumbnails() {
        const mediaContainer = document.querySelector('.product-media-container');

        // Gather all slides. Each <li> contains an <img> we can clone for the thumb.
        let slides = mediaContainer
            ? [...mediaContainer.querySelectorAll('.splide__slide')]
            : [];

        if (!mediaContainer || slides.length < 2) return;

        // Build the rail
        const rail = document.createElement('div');
        rail.classList.add('pdp-thumb-rail');

        slides.forEach((slide, i) => {
          if (i === 1 && document.querySelector('.test-2-variant-2')) {
            const heroVideo = document.querySelector('.pdp-hero-video video');
            if (heroVideo) {
                const videoThumb = document.createElement('button');
                videoThumb.classList.add('pdp-thumb', 'video-thumb');
                videoThumb.setAttribute('aria-label', 'View video');
                
                const vImg = document.createElement('img');
                // Use video poster if it exists, otherwise a placeholder/fallback
                vImg.src = heroVideo.poster || ''; 
                vImg.width = 80;
                vImg.height = 80;
                vImg.style.objectFit = 'cover';

                videoThumb.appendChild(vImg);
                rail.appendChild(videoThumb);

                videoThumb.addEventListener('click', () => {
                    const movedVideo = document.querySelector('.moved-video');
                    movedVideo?.closest('.splide__slide')?.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'nearest' 
                    });
                });
            }
          }

            const sourceImg = slide.querySelector('img');
            if (!sourceImg) return;

            const thumb = document.createElement('button');
            thumb.classList.add('pdp-thumb');
            if(i == 0) thumb.classList.add('pdp-thumb--active')
            thumb.setAttribute('aria-label', `View image ${i + 1}`);
            thumb.dataset.thumbIndex = i;

            const img = document.createElement('img');
            img.src = sourceImg.src;
            img.alt = sourceImg.alt || '';
            img.loading = 'lazy';
            img.width = 80;
            img.height = 80;

            // Higher-res src via srcset if available
            if (sourceImg.srcset) {
                // Pick the smallest entry from srcset for the thumb
                const firstSrcset = sourceImg.srcset.split(',')[0].trim().split(' ')[0];
                if (firstSrcset) img.src = firstSrcset;
            }

            thumb.appendChild(img);
            rail.appendChild(thumb);

            // Click: scroll the main image into view
            thumb.addEventListener('click', () => {
                slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
        });

        // Insert the rail BEFORE the splide element so it sits to the left
        const splide = mediaContainer.querySelector('.splide--product');
        if (splide) {
            // Wrap the splide + rail together so we can flex them side by side
            const wrapper = document.createElement('div');
            wrapper.classList.add('pdp-media-with-thumbs');
            
            if(document.querySelector('.test-2-variant-2')){
              const heroVideo = document.querySelector('.pdp-hero-video video');
              if(heroVideo){
                const cloneVideo =heroVideo.cloneNode(true);
                cloneVideo.classList.add('moved-video')
                const clonedHeroVideoWrapper = document.createElement('li')
                clonedHeroVideoWrapper.classList.add('splide__slide', 'bg-scheme-background', 'max-lg:[.splide:not(.is-active)_&]:w-full');
                clonedHeroVideoWrapper.appendChild(cloneVideo)
                splide.querySelector('.splide__list').insertBefore(clonedHeroVideoWrapper, splide.querySelectorAll('.splide__list li.splide__slide')[1]);
              }
            }

            splide.parentNode.insertBefore(wrapper, splide);
            wrapper.appendChild(splide);
            wrapper.appendChild(rail);
        }

        slides = mediaContainer
        ? [...mediaContainer.querySelectorAll('.splide__slide')]
        : [];
        // Set up the scroll observer for active-thumb tracking
        this._setupThumbObserver(slides, rail);
    }

 _setupThumbObserver(slides, rail) {
        const thumbButtons = [...rail.querySelectorAll('.pdp-thumb')];

        let activeIndex = 0;
        let rafId = null;

        const setActive = (index) => {
            if (index === activeIndex) return;
            activeIndex = index;
            thumbButtons.forEach((btn, i) => {
                btn.classList.toggle('pdp-thumb--active', i === index);
            });
        };

        // Pick whichever slide's top edge is closest to the viewport midpoint
        // (from above). One deterministic winner, zero flicker.
        const pick = () => {
            const mid = window.innerHeight / 2;
            let bestIdx = 0;
            let bestDist = Infinity;

            slides.forEach((slide, i) => {
                const { top } = slide.getBoundingClientRect();
                // Distance from the slide's top edge to the viewport midpoint.
                // We prefer slides whose top is at or above the midpoint.
                const dist = Math.abs(top - mid);
                if (dist < bestDist) {
                    bestDist = dist;
                    bestIdx = i;
                }
            });

            setActive(bestIdx);
            rafId = null;
        };

        const onScroll = () => {
            if (!rafId) rafId = requestAnimationFrame(pick);
        };

        window.addEventListener('scroll', onScroll, { passive: true });

        // Run once immediately so the first thumb is active on load
        pick();
    }
}

new PDPTestVariant();


/*** Test PDP Changes End ***/


